"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidationNFT = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var web3_1 = __importDefault(require("web3"));
function useValidationNFT(_a) {
    var userCurrencyBalance = _a.userCurrencyBalance, userCurrencyContribution = _a.userCurrencyContribution, currencyValue = _a.currencyValue, tokenValue = _a.tokenValue, tierAllocation = _a.tierAllocation, tokensBalance = _a.tokensBalance, selectedItem = _a.selectedItem;
    var currencyError;
    try {
        var wei = getWei(currencyValue);
        currencyError = validateCurrencyValue({
            wei: wei,
            userBalance: userCurrencyBalance,
        });
    }
    catch (e) {
        currencyError = e.toString();
    }
    var tokensLeft = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.sold)
        ? selectedItem.supply - selectedItem.sold
        : selectedItem.supply;
    var tokenError;
    try {
        tokenError = validateTokenValue({
            tokensLeft: tokensLeft,
            amount: parseInt(tokenValue, 10),
            limitPerWallet: selectedItem.limit,
            balance: tokensBalance[selectedItem.id].toNumber(),
            maxTotalInCurrency: tierAllocation,
            totalContribution: userCurrencyContribution,
        });
    }
    catch (e) {
        tokenError = e.toString();
    }
    return {
        currencyError: currencyError,
        tokenError: tokenError,
    };
}
exports.useValidationNFT = useValidationNFT;
function getWei(value) {
    try {
        return new bn_js_1.default(web3_1.default.utils.toWei(value));
    }
    catch (e) {
        throw "Invalid value";
    }
}
function validateCurrencyValue(_a) {
    var wei = _a.wei, userBalance = _a.userBalance;
    if (wei.gt(userBalance)) {
        return "Not enough funds";
    }
}
function validateTokenValue(_a) {
    var amount = _a.amount, tokensLeft = _a.tokensLeft, limitPerWallet = _a.limitPerWallet, balance = _a.balance, maxTotalInCurrency = _a.maxTotalInCurrency, totalContribution = _a.totalContribution;
    if (amount > tokensLeft) {
        return tokensLeft > 0 ? "Not enough tokens left" : "Sold out";
    }
    if (limitPerWallet && balance >= limitPerWallet) {
        return "Reached limit per wallet for this item";
    }
    if ((maxTotalInCurrency === null || maxTotalInCurrency === void 0 ? void 0 : maxTotalInCurrency.gtn(0)) && totalContribution.gte(maxTotalInCurrency)) {
        return "Reached allocation limit";
    }
}
